var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocalAndRegionalPolitics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Presentation-Desk-Notes--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Presentation Desk Notes Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.72 19.37a0.26 0.26 0 0 0 -0.22 0.14 0.24 0.24 0 0 0 0 0.26c0.38 0.52 1 1.35 1 1.35a2 2 0 0 0 1.56 0.75h6.51a0.25 0.25 0 0 1 0.25 0.25v1a0.75 0.75 0 0 0 0.75 0.75h3a0.74 0.74 0 0 0 0.75 -0.75v-1a0.25 0.25 0 0 1 0.25 -0.25h6.35a2 2 0 0 0 1.56 -0.75s0.63 -0.83 1 -1.35a0.23 0.23 0 0 0 0 -0.26 0.26 0.26 0 0 0 -0.22 -0.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.37a0.25 0.25 0 0 0 0.21 -0.1 0.25 0.25 0 0 0 0 -0.22c-0.59 -1.84 -3.52 -10.8 -3.52 -10.8a2 2 0 0 0 -1.9 -1.38H8.16a0.26 0.26 0 0 1 -0.2 -0.1 0.24 0.24 0 0 1 0 -0.23l0.61 -1.75a1 1 0 0 1 1 -0.67h0.72a0.26 0.26 0 0 1 0.21 0.12 2 2 0 0 0 1.65 0.88h1.5a2 2 0 0 0 0 -4h-1.5a2 2 0 0 0 -1.73 0.88 0.25 0.25 0 0 1 -0.21 0.11h-0.72a3 3 0 0 0 -2.83 2l-0.91 2.6a0.26 0.26 0 0 1 -0.22 0.17 2 2 0 0 0 -1.75 1.37s-2.93 9 -3.52 10.8a0.25 0.25 0 0 0 0 0.22 0.25 0.25 0 0 0 0.21 0.1Zm-5.12 -2.64a0.46 0.46 0 0 1 -0.08 0.44 0.48 0.48 0 0 1 -0.4 0.2H6.24a0.49 0.49 0 0 1 -0.4 -0.2 0.53 0.53 0 0 1 -0.08 -0.44L8 8.23a0.5 0.5 0 0 1 0.48 -0.36h7.22a0.5 0.5 0 0 1 0.48 0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocalAndRegionalPolitics);
export default ForwardRef;